module.exports = __webpack_public_path__ + "img/trash.53341312.svg";